import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiService} from '../../service/api.service';
import {FileReference} from '../../class/file-reference';
import {UPLOAD_KIND} from '../../class/file/upload-kind.enum';

@Component({
  selector: 'app-attachmentuploader',
  templateUrl: './attachmentuploader.component.html',
  styleUrls: ['./attachmentuploader.component.css']
})
export class AttachmentuploaderComponent implements OnInit {

  selectedFiles: FileList;
  uploading: boolean;
  uploadError: boolean;

  @Input()
  uploadKind: UPLOAD_KIND;

  @Output()
  onFileUploaded = new EventEmitter<FileReference[]>();

  @Output()
  onFileAdded = new EventEmitter<void>();

  constructor(private apiService: ApiService) {
  }

  ngOnInit() {
  }

  onFileChange(event) {
    this.selectedFiles = event.target.files;
    this.onFileAdded.emit();
  }

  uploadAttachments(objectID: string) {
    if (this.selectedFiles) {
      this.uploading = true;
      const len = this.selectedFiles.length;
      // upload file to backed
      const formData = new FormData();
      for (let i = 0; i <= len - 1; i++) {
        const fileToUpload = this.selectedFiles.item(i);
        formData.append('file', fileToUpload, fileToUpload.name);
      }

      this.apiService.uploadFiles(formData, objectID, this.uploadKind).subscribe(value => {
        this.onFileUploaded.emit(value);
        this.selectedFiles = null;
        this.uploading = false;
      }, error => {
        this.uploadError = true;
        this.uploading = false;
      });
    }
  }
}
